<template>
  <div class="index">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <home></home>
        </div>
        <div class="swiper-slide">
          <purpose></purpose>
        </div>
        <div class="swiper-slide">
          <arrange></arrange>
        </div>
        <div class="swiper-slide">
          <require></require>
        </div>
        <div class="swiper-slide">
          <rules></rules>
        </div>
        <div class="swiper-slide">
          <setting></setting>
        </div>
        <div class="swiper-slide">
          <qrcode></qrcode>
        </div>
      </div>
      <!-- 如果需要分页器 -->
<!--      <div class="swiper-pagination"></div>-->

<!--       如果需要导航按钮 -->
<!--      <div class="swiper-button-prev"></div>-->
<!--      <div class="swiper-button-next"></div>-->

      <!-- 如果需要滚动条 -->
<!--      <div class="swiper-scrollbar"></div>-->
      <div class="arrow">
        <div><img style="outline: none" src="../assets/arrow.png" /></div>
      </div>
    </div>
  </div>
</template>
<script>

  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import home from './page/home'
  import purpose from './page/purpose'
  import arrange from './page/arrange'
  import require from './page/require'
  import rules from './page/rules'
  import setting from './page/setting'
  import qrcode from './page/qrcode'
  export default {
    components: {
      home,
      purpose,
      arrange,
      require,
      rules,
      setting,
      qrcode
    },
    mounted() {
      var mySwiper = new Swiper ('.swiper-container', {
        direction: 'vertical', // 垂直切换选项
        // loop: true, // 循环模式选项

        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
        },

        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.arrow img'
        },

        // 如果需要滚动条
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      })
    }
  }
</script>
<style>
  .index {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .swiper-container {

    width: 100%;
    height: 100%;
    position: relative;
  }
  .swiper-slide {
    width: 100%;
    height: 100%;
  }
  .arrow {
    text-align: center;
    position: absolute;
    width: 100%;
    bottom: 0;
    z-index: 1;
  }
  .arrow div {
    margin-bottom: 5vw;
  }
  .arrow img {
    width: 12vw;
  }
  .swiper-button-disabled {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue